/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-nested-ternary */
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Grid, IconButton, Tooltip } from '@mui/material';
/**
 * Collapse or expand action icon implementation
 * @param {Boolean} isDisplay - Value to determine the icon to display
 * @param {Function} onClick - Function to trigger on click event
 * @returns
 */
const CollapseIcon = ({ isDisplay, onClick, tooltipText = false }) => (
  <Grid item>
    <Tooltip
      title={
        tooltipText
          ? isDisplay
            ? 'Hide Value'
            : 'Show Value'
          : isDisplay
            ? 'Minimize Frame'
            : 'Maximize Frame'
      }
      placement="top"
    >
      <IconButton
        color="inherit"
        size="small"
        sx={{
          '& .MuiSvgIcon-root': {
            width: '1.5rem',
            height: '1.25rem',
          },
        }}
        onClick={onClick}
      >
        {isDisplay ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
      </IconButton>
    </Tooltip>
  </Grid>
);
//
export default CollapseIcon;
